export default {
  user: {
    userInfo: !!sessionStorage.user ? JSON.parse(sessionStorage.user) : null,
    admins: [],
    filteredUsers: []
  },
  claims: {
    claims: []
  },
  flags: {
    flagged_countries: [],
    flagged_ports: []
  },
  policies: {
    uploaded_policies: [],
    pending_policies: [],
    quotes: {
      results: []
    },
    quote_goods: [],
    filteredPolicies: []
  },
  goods: {
    goods: []
  },
  quotes: {
    quotes: []
  },
  quote: {
    currencies: [],
    countries: [],
    conveyances: [],
    destinationTowns: [],
    destinationPorts: [],

    goods: [],
    goodsSections: [],

    quote: !!sessionStorage.quote ? JSON.parse(sessionStorage.quote) : null,
    documents: !!sessionStorage.documents
      ? JSON.parse(sessionStorage.documents)
      : null
  },
  insurers: {
    insurers: [],
    insurers_by_premiums: [],
    otherRates: []
  },
  covers: {
    openCovers: [],
    companies: [],
    corporates: []
  },
  brokers: {
    agencies: [],
    brokers: [],
    broker_admins: [],
    partners: [],
    intermediaries: [],
    bank_agencies: [],
    filteredBrokers: []
  },
  regions: {
    regions: [],
    filteredRegion: []
  },
  limits: {
    vesselLimits: [],
    consignmentLimits: []
  },
  rates: {
    comparisonOtherRates: [],
    otherRates: [],
    stampDuty: []
  },
  discounts: {
    discounts: []
  },
  currencies: {
    currencies: [],
    currencyRate: {},
    rates: []
  },
  payments: {
    payments: []
  },
  reports: {
    mci: {},
    policies: {},
    goods: {},
    sales: {},
    taxes: {},

    map_policies: [],
    geojson: {},

    revenue_summary: {
      total_sum_premium: 0,
      total_sum_insured: 0,
      total_sum_cfr: 0
    }
  },
  branches: {
    branches: [],
    regions: [],
    insurers: []
  },
  dashboardData: {
    policies: [],
    filteredPolicies: [],
    premiumRates: [],
    premium: {
      total_sum_premium: 0,
      total_sum_insured: 0,
      total_sum_cfr: 0
    },
    purchaseTypeCount: {
      credit: 0,
      open_cover: 0,
      cash: 0
    },
    claim_count: {
      this_month: 0,
      this_week: 0,
      this_year: 0,
      today: 0
    },
    commissions: {
      this_month: 0,
      this_week: 0,
      this_year: 0,
      today: 0
    },
    policy_count: {
      this_month: 0,
      this_week: 0,
      this_year: 0,
      today: 0
    },
    premiumByType: {
      total_cash: 0,
      total_open_cover: 0,
      total_credit: 0
    },
    policyCountSummary: {
      this_month: 0,
      this_week: 0,
      this_year: 0,
      today: 0
    },
    commissionSummary: {
      this_month: 0,
      this_week: 0,
      this_year: 0,
      today: 0
    },
    monthlyCount: {
      0: { jan: 0 },
      1: { feb: 0 },
      2: { mar: 0 },
      3: { apr: 0 },
      4: { may: 0 },
      5: { jun: 0 },
      6: { jul: 0 },
      7: { aug: 0 },
      8: { sept: 0 },
      9: { oct: 0 },
      10: { nov: 0 },
      11: { dec: 0 }
    },
    weeklySummary: []
  },
  session: !!sessionStorage.user,
  error: false,
  errorMessage: null,
  fetching: false,
  fetched: false
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js